import { Core } from "@faire/design-tokens";
import styled from "styled-components";

// eslint-disable-next-line @faire/no-text-transform
export const EyebrowText = styled.label<{ $color?: string }>`
  letter-spacing: 2px;
  text-transform: uppercase;
  color: ${(props) => props.$color ?? Core.text.subdued};
`;
